import { useTheme } from "@material-ui/core";
import React from "react";
import { ReferenceInput, SelectInput, useTranslate } from "react-admin";
import SubmitFilters from "../components/filters/SubmitFilters";

const Filters = (props) => {
	const translate = useTranslate();
	const theme = useTheme();
	return (
		<SubmitFilters {...props}>
			<ReferenceInput
				label={translate("resources.contests.name", 1)}
				source="contest_id"
				fullWidth
				reference="contests"
				resettable
				alwaysOn
				style={{ marginTop: theme.spacing(4) }}
			>
				<SelectInput optionText="fullname" />
			</ReferenceInput>
		</SubmitFilters>
	);
};
export default Filters;
